import { render, staticRenderFns } from "./PerformanceStatistics.vue?vue&type=template&id=95652ff2&scoped=true&"
import script from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
export * from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
import style1 from "./PerformanceStatistics.vue?vue&type=style&index=1&id=95652ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95652ff2",
  null
  
)

export default component.exports